export const LOCALES_LIST = ['en', 'uk'];
export const CLIENT_APP_LOCALES_LIST = ['uk', 'en'];
export const FORM_LANG = {
  uk: 'uk',
  en: 'en',
};
